export const pageViewData = {
    accountingPeriodPage: {
        type: 'simpleCard',
        entity: 'accountingPeriod',
        path: 'accountingPeriod',
        view: 'accountingPeriodCard'
    },
    adminSettingsPage: {
        type: 'simpleCard',
        entity: 'adminSettings',
        path: 'adminSettings',
        view: 'adminSettingsCard'
    },
    assetPage: {
        type: 'simpleCard',
        entity: 'asset',
        path: 'asset',
        view: 'assetCard'
    },
    bomVersionPage: {
        type: 'simpleCard',
        entity: 'bomVersion',
        path: 'product/:id/bomVersion',
        view: 'bomVersionCard'
    },
    campaignPage: {
        type: 'simpleCard',
        entity: 'campaign',
        path: 'campaign',
        view: 'campaignCard'
    },
    contactMultiPage: {
        type: 'tabView',
        entity: 'contact',
        path: 'contact',
        view: 'contactTabView'
    },
    contactPage: {
        type: 'simpleCard',
        entity: 'contact',
        path: 'contact',
        view: 'contactCard'
    },
    contactPersonPage: {
        type: 'simpleCard',
        entity: 'contactPerson',
        path: 'contact/:id/contactPerson',
        view: 'contactPersonCard'
    },
    createOrgCardOrganization: {
        type: 'simpleCard',
        entity: 'organization',
        path: 'organization',
        view: 'createOrgCardOrganization'
    },
    createOrgCardUser: {
        type: 'simpleCard',
        entity: 'user',
        path: 'user',
        view: 'createOrgCardUser'
    },
    creditNoteNewPage: {
        type: 'multiView',
        entity: 'invoice',
        path: 'invoice',
        view: 'creditNoteEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        //Triggers the Transition Layer
        transition: {
            active: true,
            type: 'invoiceToCreditNote'
        }
    },
    creditNotePage: {
        type: 'filteredView',
        entity: 'creditNote',
        path: 'creditNote',
        //Options needed for FilteredView
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "creditNoteViewMV" },
                { filterValue: "draft", filterResult: "creditNoteEditMV" }
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings']
    },
    customerGroupPage: {
        type: 'simpleCard',
        entity: 'customerGroup',
        path: 'customerGroup',
        view: 'customerGroupCard'
    },
    docBrowserPage: {
        type: 'multiView',
        entity: 'folder',
        path: 'folder',
        view: 'docBrowserMV'
    },
    documentPage: {
        type: 'filteredView',
        entity: 'document',
        path: 'document',
        filter: {
            filterKey: 'fileType',
            viewType: 'multiView',
            defaultFilterResult: 'documentFileMV',
            filterArray: [
                { filterValue: 'pdf', filterResult: 'documentFileMV' },
                { filterValue: 'image', filterResult: 'documentFileMV' },
                { filterValue: 'richtext', filterResult: 'documentRichTextMV' },
                { filterValue: 'link', filterResult: 'documentFileMV' }
            ]
        }
    },
    employeeCard: {
        type: 'simpleCard',
        entity: 'employee',
        path: 'employee',
        view: 'employeeCard'
    },
    // Created from a Purchases › Inbox document (38.04): the page loads the
    // inbox entry and the transition turns it into a draft expense with the
    // document attached; the suggestion panel does the rest.
    expenseFromInboxPage: {
        type: 'multiView',
        entity: 'inboxDocument',
        path: 'inboxDocument',
        view: 'expenseEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['buyer', 'root'] }, 'purchasesSettings'],
        backOverride: '/purchases/inbox',
        transition: {
            active: true,
            type: 'inboxDocumentToExpense'
        },
        // Worked through in turn: a progress bar on top, and Save opens the
        // next To do — the inbox list's own filter and order — until none is left.
        queue: {
            entity: 'inboxDocument',
            filter: 'status:new;archived:false',
            orderBy: 'uploadedAt',
            direction: 'desc',
            path: '/purchases/expense/newFromInbox/:id',
            donePath: '/purchases/inbox',
            label: 'purchases.inbox.queue.progress'
        }
    },
    // Created from a purchase order: the page loads the order and the transition
    // turns it into a draft expense; saving posts the expense, not the order.
    expenseFromPurchaseOrderPage: {
        type: 'multiView',
        entity: 'purchaseOrder',
        path: 'purchaseOrder',
        view: 'expenseEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['buyer', 'root'] }, 'purchasesSettings'],
        backOverride: '/purchases/expense',
        transition: {
            active: true,
            type: 'purchaseOrderToExpense'
        }
    },
    expensePage: {
        type: 'filteredView',
        entity: 'expense',
        path: 'expense',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "expenseViewMV" },
                { filterValue: "draft", filterResult: "expenseEditMV" }
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['buyer', 'root'] }, 'purchasesSettings'],
        backOverride: '/purchases/expense'
    },
    // The expense is its own detail: it has no payment tranches to list.
    expensePaymentPage: {
        type: 'MasterDetailView',
        masterEntity: 'expense',
        view: 'expensePaymentMDView',
        detailFromMaster: true
    },
    // A journal entered in a grid. Only the draft differs: once posted, it
    // reads exactly like any other journal.
    fastJournalPage: {
        type: 'filteredView',
        entity: 'journal',
        path: 'journal',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "draft", filterResult: "fastJournalEditMV" },
                { filterValue: "posted", filterResult: "journalViewMV" },
                { filterValue: "reversing", filterResult: "journalViewMV" },
                { filterValue: "reversed", filterResult: "journalViewMV" }
            ]
        }
    },
    folderPage: {
        type: 'simpleCard',
        entity: 'folder',
        path: 'folder',
        view: 'folderCard'
    },
    glAccountPage: {
        type: 'simpleCard',
        entity: 'glAccount',
        path: 'glAccount',
        view: 'glAccountCard'
    },
    hallPage: {
        type: 'simpleCard',
        entity: 'hall',
        path: 'warehouse/:id/hall',
        view: 'hallCard'
    },
    interactionPage: {
        type: 'simpleCard',
        entity: 'interaction',
        path: 'contact/:id/interaction',
        view: 'interactionCard'
    },
    inventoryLedgerDetailPage: {
        type: 'simpleDisplay',
        entity: 'inventoryLedger',
        path: 'inventoryLedger',
        view: 'inventoryLedgerDisplayView',
        loadSettings: ['adminSettings', 'inventorySettings']
    },
    inventorySettingsPage: {
        type: 'simpleCard',
        entity: 'inventorySettings',
        path: 'inventorySettings',
        view: 'inventorySettingsCard'
    },
    invoiceFromContactPage: {
        type: 'multiView',
        entity: 'invoice',
        path: 'invoice',
        view: 'contactInvoiceEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        //Triggers the Transition Layer
        transition: {
            active: true,
            type: 'contactToInvoice'
        }
    },
    invoiceFromProjectPage: {
        type: 'multiView',
        entity: 'project',
        path: 'project',
        view: 'invoiceEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        transition: {
            active: true,
            type: 'projectToInvoice'
        }
    },
    invoiceNewFromQuotePage: {
        type: 'multiView',
        entity: 'quote',
        path: 'quote',
        view: 'invoiceEditMV',
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        backOverride: '/sales/invoice',
        //Triggers the Transition Layer
        transition: {
            active: true,
            type: 'quoteToInvoice'
        }
    },
    invoicePage: {
        type: 'filteredView',
        entity: 'invoice',
        path: 'invoice',
        //Options needed for FilteredView
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "invoiceViewMV" },
                { filterValue: "draft", filterResult: "invoiceEditMV" }
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        backOverride: '/sales/invoice'
    },
    invoicePaymentPage: {
        type: 'MasterDetailView',
        masterEntity: 'invoice',
        detailEntity: 'invoicePayment',
        view: 'invoicePaymentMDView',
        detailFilter: { invoiceId: 'id' }
    },
    itemPricePage: {
        type: 'simpleCard',
        entity: 'itemPrice',
        path: 'product/:id/itemPrice',
        view: 'itemPriceCard'
    },
    itemPricePageNew: {
        type: 'simpleCard',
        entity: 'itemPrice',
        path: 'product/:id/itemPrice',
        view: 'itemPriceCard',
        transition: {
            active: true,
            type: 'productToItemPrice'
        }
    },
    journalPage: {
        type: 'filteredView',
        entity: 'journal',
        path: 'journal',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "draft", filterResult: "journalEditMV" },
                { filterValue: "posted", filterResult: "journalViewMV" },
                { filterValue: "reversing", filterResult: "journalViewMV" },
                { filterValue: "reversed", filterResult: "journalViewMV" }
            ]
        }
    },
    locationMultiPage: {
        type: 'tabView',
        entity: 'location',
        path: 'location',
        view: 'locationTabView'
    },
    locationPage: {
        type: 'simpleCard',
        entity: 'location',
        path: 'location',
        view: 'locationCard'
    },
    machineDowntimePage: {
        type: 'simpleCard',
        entity: 'machineDowntime',
        path: 'machine/:id/machineDowntime',
        view: 'machineDowntimeCard'
    },
    machinePage: {
        type: 'simpleCard',
        entity: 'machine',
        path: 'machine',
        view: 'machineCard'
    },
    manufacturingSettingsPage: {
        type: 'simpleCard',
        entity: 'manufacturingSettings',
        path: 'manufacturingSettings',
        view: 'manufacturingSettingsCard'
    },
    // Studio (30.03.08). `model/status` is one record — the org's customization
    // state, with its drafts validated live — and `modelOverlay` addresses an
    // overlay by its URL-safe Studio id.
    modelFieldPage: {
        type: 'simpleCard',
        entity: 'modelField',
        path: 'modelField',
        view: 'modelFieldCard'
    },
    modelOverlayPage: {
        type: 'simpleCard',
        entity: 'modelOverlay',
        path: 'modelOverlay',
        view: 'modelOverlayCard'
    },
    modelStatusPage: {
        type: 'simpleCard',
        entity: 'modelStatus',
        path: 'model/status',
        view: 'modelStatusCard'
    },
    modelVersionPage: {
        type: 'simpleCard',
        entity: 'modelVersion',
        path: 'model/versions',
        view: 'modelVersionCard'
    },
    organizationCard: {
        type: 'simpleCard',
        entity: 'organization',
        path: 'organization',
        view: 'organizationCard'
    },
    paymentAccountMultiPage: {
        type: 'tabView',
        entity: 'paymentAccount',
        path: 'paymentAccount',
        view: 'paymentAccountTabView'
    },
    paymentAccountPage: {
        type: 'simpleCard',
        entity: 'paymentAccount',
        path: 'paymentAccount',
        view: 'paymentAccountCard'
    },
    paymentTermPage: {
        type: 'simpleCard',
        entity: 'paymentTerm',
        path: 'paymentTerm',
        view: 'paymentTermCard'
    },
    paymentTransactionPage: {
        type: 'simpleCard',
        entity: 'paymentTransaction',
        path: 'paymentAccount/:id/paymentTransaction',
        view: 'paymentTransactionCard',
        fieldsLogic: ['currency']
    },
    plantPage: {
        type: 'simpleCard',
        entity: 'plant',
        path: 'plant',
        view: 'plantCard'
    },
    portalInvoicePage: {
        type: 'multiView',
        entity: 'invoice',
        path: 'invoice',
        view: 'portalInvoiceViewMV',
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings']
    },
    portalPage: {
        type: 'simpleCard',
        entity: 'portal',
        path: 'portal',
        view: 'portalCard'
    },
    postingRulePage: {
        type: 'simpleCard',
        entity: 'postingRule',
        path: 'postingRule',
        view: 'postingRuleCard'
    },
    priceListItemPage: {
        type: 'simpleCard',
        entity: 'priceListItem',
        path: 'priceList/:id/priceListItem',
        view: 'priceListItemCard'
    },
    priceListPage: {
        type: 'tabView',
        entity: 'priceList',
        path: 'priceList',
        view: 'priceListTabView'
    },
    priceListPageNew: {
        type: 'simpleCard',
        entity: 'priceList',
        path: 'priceList',
        view: 'priceListCard'
    },
    productFamilyPage: {
        type: 'simpleCard',
        entity: 'productFamily',
        path: 'productFamily',
        view: 'productFamilyCard'
    },
    productFamilyTabPage: {
        type: 'tabView',
        entity: 'productFamily',
        path: 'productFamily',
        view: 'productFamilyTabView'
    },
    productGroupPage: {
        type: 'simpleCard',
        entity: 'productGroup',
        path: 'productGroup',
        view: 'productGroupCard'
    },
    productMultiPage: {
        type: 'tabView',
        entity: 'product',
        path: 'product',
        view: 'productTabView'
    },
    productPage: {
        type: 'simpleCard',
        entity: 'product',
        path: 'product',
        view: 'productCard'
    },
    // Project Management
    projectCard: {
        type: 'simpleCard',
        entity: 'project',
        path: 'project',
        view: 'projectCard'
    },
    projectSettingsPage: {
        type: 'simpleCard',
        entity: 'projectSettings',
        path: 'projectSettings',
        view: 'projectSettingsCard'
    },
    projectTabPage: {
        type: 'tabView',
        entity: 'project',
        path: 'project',
        view: 'projectTabView'
    },
    projectTaskPage: {
        type: 'simpleCard',
        entity: 'projectTask',
        path: 'project/:id/projectTask',
        view: 'projectTaskCard',
        loadSettings: ['projectSettings']
    },
    projectTeamPage: {
        type: 'simpleCard',
        entity: 'employee',
        path: 'employee',
        view: 'projectTeamCard'
    },
    purchaseOrderPage: {
        type: 'filteredView',
        entity: 'purchaseOrder',
        path: 'purchaseOrder',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "purchaseOrderViewMV" },
                { filterValue: "draft", filterResult: "purchaseOrderEditMV" }
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['buyer', 'root'] }, 'purchasesSettings'],
        backOverride: '/purchases/purchaseOrder'
    },
    purchaseRequestPage: {
        type: 'filteredView',
        entity: 'purchaseRequest',
        path: 'purchaseRequest',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "draft", filterResult: "purchaseRequestDraftMV" },
                { filterValue: "submitted", filterResult: "purchaseRequestSubmittedMV" },
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['buyer', 'root'] }, 'purchasesSettings'],
        backOverride: '/purchases/purchaseRequest'
    },
    purchasesSettingsPage: {
        type: 'simpleCard',
        entity: 'purchasesSettings',
        path: 'purchasesSettings',
        view: 'purchasesSettingsCard'
    },
    qualityCheckPage: {
        type: 'simpleCard',
        entity: 'qualityCheck',
        path: 'qualityCheck',
        view: 'qualityCheckCard'
    },
    quotePage: {
        type: 'filteredView',
        entity: 'quote',
        path: 'quote',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "quoteViewMV" },
                { filterValue: "draft", filterResult: "quoteEditMV" }
            ]
        },
        loadSettings: [{ key: 'adminSettings', sections: ['seller', 'root'] }, 'salesSettings'],
        backOverride: '/sales/quote'
    },
    rackPage: {
        type: 'simpleCard',
        entity: 'rack',
        path: 'rack',
        view: 'rackCard'
    },
    reservationPage: {
        type: 'simpleCard',
        entity: 'stockReservation',
        path: 'stockReservation',
        view: 'reservationCard'
    },
    routingVersionPage: {
        type: 'simpleCard',
        entity: 'routingVersion',
        path: 'routingVersion',
        view: 'routingVersionCard'
    },
    salesSettingsPage: {
        type: 'simpleCard',
        entity: 'salesSettings',
        path: 'salesSettings',
        view: 'salesSettingsCard'
    },
    serviceContractPage: {
        type: 'simpleCard',
        entity: 'serviceContract',
        path: 'serviceContract',
        view: 'serviceContractCard'
    },
    serviceLocationPage: {
        type: 'simpleCard',
        entity: 'serviceLocation',
        path: 'serviceLocation',
        view: 'serviceLocationCard'
    },
    servicePartsLinePage: {
        type: 'simpleCard',
        entity: 'servicePartsLine',
        path: 'serviceWorkOrder/:id/servicePartsLine',
        view: 'servicePartsLineCard'
    },
    serviceSettingsPage: {
        type: 'simpleCard',
        entity: 'serviceSettings',
        path: 'serviceSettings',
        view: 'serviceSettingsCard'
    },
    serviceSkillPage: {
        type: 'simpleCard',
        entity: 'serviceSkill',
        path: 'serviceSkill',
        view: 'serviceSkillCard'
    },
    serviceTechnicianPage: {
        type: 'simpleCard',
        entity: 'serviceTechnician',
        path: 'serviceTechnician',
        view: 'serviceTechnicianCard'
    },
    serviceTicketPage: {
        type: 'tabView',
        entity: 'serviceTicket',
        path: 'serviceTicket',
        view: 'serviceTicketTabView',
        loadSettings: ['serviceSettings']
    },
    serviceTicketPlannerPage: {
        type: 'plannerPage',
        view: 'serviceTicketPlanner'
    },
    serviceTypePage: {
        type: 'simpleCard',
        entity: 'serviceType',
        path: 'serviceType',
        view: 'serviceTypeCard'
    },
    serviceWorkerPage: {
        type: 'simpleCard',
        entity: 'employee',
        path: 'employee',
        view: 'serviceWorkerCard'
    },
    serviceWorkOrderPage: {
        type: 'tabView',
        entity: 'serviceWorkOrder',
        path: 'serviceWorkOrder',
        view: 'serviceWorkOrderTabView',
        loadSettings: ['serviceSettings']
    },
    shiftPage: {
        type: 'simpleCard',
        entity: 'shift',
        path: 'shift',
        view: 'shiftCard'
    },
    shipmentFromQuotePage: {
        type: 'multiView',
        entity: 'quote',
        path: 'quote',
        view: 'stockShipmentEditMV',
        loadSettings: ['adminSettings', 'inventorySettings'],
        backOverride: '/inventory/shipment',
        transition: {
            active: true,
            type: 'quoteToShipment'
        }
    },
    stockAdjustmentPage: {
        type: 'filteredView',
        entity: 'stockAdjustment',
        path: 'stockAdjustment',
        //Options needed for FilteredView
        filter: {
            filterKey: 'state',
            viewType: 'switchView',
            filterArray: [
                { filterValue: "draft", filterResult: "stockAdjustmentCard", filterView: "cardView" },
                { filterValue: "final", filterResult: "stockAdjustmentDisplayView", filterView: "displayView" }
            ]
        },
        loadSettings: ['adminSettings', 'inventorySettings']
    },
    stockMovementPage: {
        type: 'filteredView',
        entity: 'stockMovement',
        path: 'stockMovement',
        //Options needed for FilteredView
        filter: {
            filterKey: 'state',
            viewType: 'switchView',
            filterArray: [
                { filterValue: "draft", filterResult: "stockMovementCard", filterView: "cardView" },
                { filterValue: "final", filterResult: "stockMovementDisplayView", filterView: "displayView" }
            ]
        },
        loadSettings: ['adminSettings', 'inventorySettings']
    },
    stockReceiptNewPage: {
        type: 'multiView',
        entity: 'purchaseOrder',
        path: 'purchaseOrder',
        view: 'stockReceiptEditMV',
        loadSettings: ['adminSettings', 'inventorySettings'],
        backOverride: '/inventory/receipt',
        transition: {
            active: true,
            type: 'purchaseOrderToStockReceipt'
        }
    },
    stockReceiptPage: {
        type: 'filteredView',
        entity: 'stockReceipt',
        path: 'stockReceipt',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "stockReceiptViewMV" },
                { filterValue: "draft", filterResult: "stockReceiptEditMV" }
            ]
        },
        loadSettings: ['adminSettings', 'inventorySettings']
    },
    stockShipmentPage: {
        type: 'filteredView',
        entity: 'stockShipment',
        path: 'stockShipment',
        //Options needed for FilteredView
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            filterArray: [
                { filterValue: "final", filterResult: "stockShipmentViewMV" },
                { filterValue: "draft", filterResult: "stockShipmentEditMV" }
            ]
        },
        loadSettings: ['adminSettings', 'inventorySettings']
    },
    supplierItemPage: {
        type: 'simpleCard',
        entity: 'supplierItem',
        path: 'product/:id/supplierItem',
        view: 'supplierItemCard'
    },
    supplierItemPageNew: {
        type: 'simpleCard',
        entity: 'supplierItem',
        path: 'product/:id/supplierItem',
        view: 'supplierItemCard'
    },
    taskKanbanView: {
        type: 'kanbanPage',
        entity: 'project',
        subEntity: 'projectTask',
        path: 'project',
        view: 'taskKanbanView'
    },
    timeEntryPage: {
        type: 'simpleCard',
        entity: 'timeEntry',
        path: 'serviceWorkOrder/:id/timeEntry',
        view: 'timeEntryCard'
    },
    userCard: {
        type: 'simpleCard',
        entity: 'organizationUser',
        path: 'organizationUser',
        view: 'userCard'
    },
    userCardNew: {
        type: 'simpleCard',
        entity: 'organizationUser',
        path: 'organizationUser',
        view: 'userCardNew'
    },
    warehouseOrderNewPage: {
        type: 'multiView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehouseOrderEditMV'
    },
    warehouseOrderPage: {
        type: 'filteredView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        filter: {
            filterKey: 'state',
            viewType: 'multiView',
            defaultFilterResult: 'warehouseOrderEditMV',
            filterArray: [
                { filterValue: 'draft', filterResult: 'warehouseOrderEditMV' },
                { filterValue: 'released', filterResult: 'warehouseOrderViewMV' },
            ]
        }
    },
    warehousePage: {
        type: 'simpleCard',
        entity: 'warehouse',
        path: 'warehouse',
        view: 'warehouseCard'
    },
    warehousePathPage: {
        type: 'simpleCard',
        entity: 'warehousePath',
        path: 'warehousePath',
        view: 'warehousePathCard'
    },
    warehousePickPage: {
        type: 'processView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehousePick',
        backOverride: '/warehouse/warehouseOrder/released?tab=pick'
    },
    warehousePutawayPage: {
        type: 'processView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehousePutaway',
        backOverride: '/warehouse/warehouseOrder/released?tab=putaway'
    },
    warehouseQuarantinePage: {
        type: 'processView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehouseQuarantine',
        backOverride: '/warehouse/warehouseOrder/released?tab=quarantine'
    },
    warehouseReturnPage: {
        type: 'processView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehouseReturn',
        backOverride: '/warehouse/warehouseOrder/released?tab=return'
    },
    warehouseTabPage: {
        type: 'tabView',
        entity: 'warehouse',
        path: 'warehouse',
        view: 'warehouseTabView'
    },
    warehouseTransferPage: {
        type: 'processView',
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        view: 'warehouseTransfer',
        backOverride: '/warehouse/warehouseOrder/released?tab=transfer'
    },
    workCapabilityPage: {
        type: 'simpleCard',
        entity: 'workCapability',
        path: 'workCapability',
        view: 'workCapabilityCard'
    },
    workCenterPage: {
        type: 'tabView',
        entity: 'workCenter',
        path: 'workCenter',
        view: 'workCenterTabView'
    },
    workDepartmentPage: {
        type: 'simpleCard',
        entity: 'workDepartment',
        path: 'workDepartment',
        view: 'workDepartmentCard'
    },
    workOperationExecutionPage: {
        type: 'compositeView',
        entity: 'workOperation',
        path: 'workOperation',
        view: 'workOperationExecutionTabView'
    },
    workOperationPage: {
        type: 'filteredView',
        entity: 'workOperation',
        path: 'workOperation',
        filter: {
            filterKey: 'state',
            viewType: 'simpleCard',
            filterArray: [
                { filterValue: 'draft', filterResult: 'workOperationCard' },
                { filterValue: 'scheduled', filterResult: 'workOperationExecutionTabView', viewType: 'compositeView' },
                { filterValue: 'inProgress', filterResult: 'workOperationExecutionTabView', viewType: 'compositeView' },
                { filterValue: 'paused', filterResult: 'workOperationExecutionTabView', viewType: 'compositeView' },
                { filterValue: 'completed', filterResult: 'workOperationExecutionTabView', viewType: 'compositeView' }
            ]
        }
    },
    workOrderPage: {
        type: 'tabView',
        entity: 'workOrder',
        path: 'workOrder',
        view: 'workOrderTabView'
    },
    workOrderPlannerPage: {
        type: 'plannerPage',
        view: 'workOrderPlanner'
    },
}
